<p class="ml-2 mr-2">Die angezeigte Legierung wird als Späne ausgebucht. Wollen Sie fortfahren?</p>

@if (loading()) {
  <div class="flex flex-row justify-center pt-2 pb-2 min-h">
    <soft-loading-spinner class="spin"></soft-loading-spinner>
  </div>
} @else {
  @if (lighterMaterials(); as lighterMaterials) {
    <div class="flex flex-col ml-2 mr-2 border-box mt-2">
      @if (((lighterMaterials?.length ?? 0) > 0)) {
        @for (item of lighterMaterials; track item; let last = $last) {
          <div (click)="selectedMaterial.set(item)" [class.border-b]="!last" [ngClass]="selectedMaterial()?.cartikelnummer === item?.cartikelnummer ? 'bg-selected' : 'bg-surface'" class="flex flex-row pt-2 pb-2 column center-v">
            <div class="flex flex-row justify-between flex-nowrap center-v">
              <div class="flex flex-col">
                @if (item?.cartikelnummer) {
                  <span class="soft-overline">{{ item?.cartikelnummer }}</span>
                }
                <strong class="text-lg">{{ item?.bezeichnung || '-' }}</strong>
                @if (item?.legierung) {
                  <span class="soft-text">{{ item?.legierung }}</span>
                }
              </div>
              @if (item?.gewicht) {
                <span class="mr-3" style="font-weight: bold; font-size: 1.25rem">{{ (item?.gewicht || 0) | number:'1.3-3' }}g</span>
              }
            </div>
          </div>
        }
      } @else {
        <div style="min-height: 70px" class="flex flex-row justify-center">
          Keine Späne gefunden!
        </div>
      }
    </div>
  }
}


@if (lighterMaterials(); as lighterMaterials) {
  <div class="flex flex-row flex-nowrap">
    <button class="soft-button secondary custom mt-3" (click)="close(null)">Abbrechen</button>
    <button class="soft-button primary custom mt-3" (click)="close(selectedMaterial())" [disabled]="(lighterMaterials?.length ?? 0) < 1 || !selectedMaterial()">Fortfahren</button>
  </div>
}


